import 'reflect-metadata'
import { render } from 'preact'
import './index.css'
import { App } from './app/app.tsx'
import { installGlobalErrorLogging } from '@core/services/install-global-error-logging'

installGlobalErrorLogging()

render(<App />, document.getElementById('app')!)
